import { t } from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import BaseListContainer from '../baseContainers/BaseListContainer';
import CriteriaCalendarRangeComponent from '../components/criteria/CriteriaCalendarRangeComponent';
import CriteriaDropdownComponent from '../components/criteria/CriteriaDropdownComponent';
import CriteriaTextComponent from '../components/criteria/CriteriaTextComponent';
import ClientService from '../services/ClientService';
import ProjectAddressService from '../services/ProjectAddressService';
import ReportedDayService from '../services/ReportedDayService';
import YesNoDialog from '../components/YesNoDialog';
import moment from 'moment';
import ReportedUserDayService from '../services/userReport/ReportedUserDayService';
import { Tooltip } from 'primereact/tooltip';
import DivContainer from '../components/DivContainer';
import InputTextareaComponent from '../components/inputs/InputTextareaComponent';
import CriteriaAutocompleteComponent from '../components/criteria/CriteriaAutocompleteComponent';

import { withRouter } from "react-router-dom";
import ProjectService from '../services/ProjectService';
import { TabView, TabPanel } from 'primereact/tabview';
import { Card } from 'primereact/card';
import { CustomMessages } from '../components/CustomMessages';
import PdfDownloadSpinner from '../components/spinner/PdfDownloadSpinner';
import BlockUi from '../components/waitPanel/BlockUi';
import ActionButton from '../components/ActionButton';
import { Chip } from 'primereact/chip';

class ReportedDayListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new ReportedDayService());
        const activeIndexParam = this.navigationContext.getParam('activeIndex');
        this.state = {
            list: [],
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            statusLevelOptions: [],
            dialogVisibile: false,
            deleteConfirmDialogVisible: false,
            openConfirmationDialogVisible: false,
            elementToRemove: undefined,
            selectAllMode: false,
            unselectedList: [],
            selectedList: [],
            choosenCards: [],
            activeIndex: activeIndexParam ? activeIndexParam : 0,
            element: {
                name: '',                
                status: {enumValue: 'ACTIVE', label: 'Aktywny'},
            },
            reportedDayTypeOptions: [
                {
                    label: 'Indywidualna',
                    value: 'SINGLE'
                },
                {
                    label: 'Grupowa',
                    value: 'REPORTED_DAY'
                },
            ]
        };
        this.clientService = new ClientService();
        this.locationService = new ProjectAddressService();
        this.userDayService = new ReportedUserDayService();
        this.projectService = new ProjectService();
        this.handleGoToNewUserDay = this.handleGoToNewUserDay.bind(this);
        this.handleOpenRemoveReportedDayDialog = this.handleOpenRemoveReportedDayDialog.bind(this);
        this.handleOpenApproveReportedDayDialog = this.handleOpenApproveReportedDayDialog.bind(this);
        this.handleOpenConfirmationReportedDayDialog = this.handleOpenConfirmationReportedDayDialog.bind(this);
        this.handleOpenRejectReportedDayDialog = this.handleOpenRejectReportedDayDialog.bind(this);
        this.handleApprove = this.handleApprove.bind(this);
        this.handleReject = this.handleReject.bind(this);
        this.searchProjects = this.searchProjects.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }

    generateCustomFooterIfPossible() {
        return null;
    }

    updateListElements(list) {

        return list;
    }


    getTableFooter(){
        const { selectedList } = this.state;
        const recordsToRejectExist = selectedList?.filter(x => x.reportType === 'SINGLE' ?
            x.level === 1 && x.status === 'TO_APPROVE' :
            x.status === 'TO_APPROVE'

        ).length > 0

        const recordsToUnlockExist = selectedList?.filter(x => x.status === 'APPROVED'
            && x.level >= 2
        ).length > 0

        const recordsToAcceptExist = selectedList?.filter(x => x.reportType === 'SINGLE' ?
            (x.level === 1 || x.level === 0) && x.status === 'TO_APPROVE' :
            x.status === 'TO_APPROVE' || x.status === 'REJECTED'

            //indywidualna karta: 0 1 2
            //grupowa: 1 2 3
        ).length > 0

        const selectAllMode = this.state.selectAllMode;
        const listPredicate = selectAllMode ? this.state.unselectedList?.length >= 0 : this.state.selectedList.length > 0;

        return (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'end',
                            gap: '10px'
                        }}
                    >
                        <div
                            style={{
                                marginRight: 'auto'
                            }}
                        >
                    </div>
                    {this.state.activeIndex >3 ? null :
                        <>
                            
                            <ActionButton
                                label={t('userReporting.confirm')}
                                className={recordsToAcceptExist && listPredicate ? "float-right header-item" : "p-disabled float-right header-item"}
                                handleClick={(e) => {
                                    this.setState({
                                        approveDialogVisible: true
                                    })
                                }}
                            />
                            <ActionButton
                                label={t('userReporting.unlock')}
                                className={recordsToUnlockExist && listPredicate ? `float-right header-item` : `p-disabled float-right header-item`}
                                handleClick={(e) => {
                                    this.setState({
                                        openConfirmationDialogVisible: true
                                    })
                                }}
                            />
                            <ActionButton
                                label={t('userReporting.reject')}
                                className={recordsToRejectExist && listPredicate ? `fullred float-right header-item` : `p-disabled fullred float-right header-item` }
                                handleClick={(e) => {
                                    this.setState({
                                        rejectDialogVisible: true
                                    })
                                }}
                            />
                        </>
                    }
                    </div>
                )
    }


    handleApprove() {
        const { criteria } = this.state
        const {selectAllMode} = this.state;
        const choosenCards = selectAllMode ? this.state.unselectedList : this.state.selectedList;
        criteria.rejectReason='';
        this.service
            .groupApprove(criteria, choosenCards.map(x =>x.id), selectAllMode)
            .then((x) => {
                this.setState({
                    unselectedList: [],
                    selectedList: [],
                    selectAll: false,
                    criteria: criteria
                }, () => {
                    this.getList()
                })
            }).catch((err) => {
                this.showErrorMessage(err.message)
            })
    }

    handleApproveSingleDay() {
        this.blockUi();
        this.service
            .approve(this.state.elementToAction.id)
            .then((result) => {
                this.showSuccessMessage('Zaakceptowano kartę pracy');
                this.unblockUi();
            })
            .catch((err) => {
                this.showErrorMessage(err.message)
                this.unblockUi();
            });
    }

    handleReject() {
        const { criteria } = this.state
        const {selectAllMode} = this.state;
        const choosenCards = selectAllMode ? this.state.unselectedList : this.state.selectedList;
        criteria.rejectReason='';
        this.service
            .groupReject(criteria, choosenCards.map(x =>x.id), this.state.rejectReason, selectAllMode)
            .then((x) => {
                this.setState({
                    unselectedList: [],
                    selectedList: [],
                    selectAll: false,
                    rejectReason: '',
                    criteria: criteria
                }, () => {
                    this.getList()
                })
            }).catch((err) => {
                this.showErrorMessage(err.message)
            })
    }

   handleSingleReject() {
        this.blockUi();
        this.service
            .reject(this.state.elementToAction.id)
            .then((result) => {
                this.showSuccessMessage('Odrzucono kartę pracy');
                this.unblockUi();
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
                this.unblockUi();
            });
    }

    handleOpen(){
        //open
        const { criteria } = this.state
        const {selectAllMode} = this.state;
        const choosenCards = selectAllMode ? this.state.unselectedList : this.state.selectedList;
        criteria.rejectReason='';
        this.service
            .groupOpen(criteria, choosenCards.map(x =>x.id), selectAllMode)
            .then((x) => {
                this.setState({
                    unselectedList: [],
                    selectedList: [],
                    selectAll: false,
                    criteria: criteria
                }, () => {
                    this.getList()
                })
            }).catch((err) => {
                this.showErrorMessage(err.message)
            })
    }
    handleSingleOpen() {
        this.blockUi();
        this.service
            .reopen(this.state.elementToAction.id)
            .then((result) => {
                this.showSuccessMessage('Karta pracy została odblokowana');
                this.unblockUi();
            })
            .catch((err) => {
                this.showErrorMessage('Nie udało się odblokować karty pracy!');
                this.unblockUi();
            });
    }


    getApproveReportedDayDialog() {
        return (
            <YesNoDialog
                id={"yn-rd-dialog"}
                visible={this.state.approveDialogVisible || this.state.singleApproveDialogVisible}
                header={this.state.approveDialogVisible ? t('userReporting.approveGroup') : t('userReporting.approve') }
                name='visible'
                onChange={(type, x, target) => {
                    if (target.value) {
                        if(this.state.approveDialogVisible ){
                            this.handleApprove();
                        } else {
                            this.handleApproveSingleDay();
                        }
                        
                        this.setState({ approveDialogVisible: false , singleApproveDialogVisible: false})
                    } else {
                        this.setState({ approveDialogVisible: false , singleApproveDialogVisible: false})
                    }
                }}
                onHide={() => this.setState({ approveDialogVisible: false , singleApproveDialogVisible: false})}
            >
                {this.state.approveDialogVisible ?  t('userReporting.confirmGroupMessage') : t('userReporting.confirmMessage') }
                </YesNoDialog>
        );
    }

    getOpenReportedDayDialog() {
        return (
            <YesNoDialog
                id={"yn-rd-dialog"}
                visible={this.state.openConfirmationDialogVisible || this.state.openSingleConfirmationDialogVisible}
                header={this.state.openConfirmationDialogVisible ? t('userReporting.openGroup') : t('userReporting.unlockHeader')  }
                name='visible'
                onChange={(type, x, target) => {
                    if (target.value) {
                        if(this.state.openConfirmationDialogVisible === true){
                            this.handleOpen();
                        } else{
                            this.handleSingleOpen();
                        }
                        
                        this.setState({ openConfirmationDialogVisible: false, openSingleConfirmationDialogVisible: false })
                    } else {
                        this.setState({ openConfirmationDialogVisible: false, openSingleConfirmationDialogVisible: false })
                    }
                }}
                onHide={() => this.setState({ openConfirmationDialogVisible: false, openSingleConfirmationDialogVisible: false })}
            >
                {/* {t('userReporting.confirmGroupMessage')} */}
                {this.state.openConfirmationDialogVisible ? 'Czy napewno chcesz odblokować zaznaczone karty pracy? ' : t('userReporting.unblockMessage') }
            </YesNoDialog>
        );
    }

    getRejectReportedDayDialog() {
        return (
            <YesNoDialog
                id={"yn-rd-dialog"}
                visible={this.state.rejectDialogVisible || this.state.singleRejectDialogVisible}
                header={this.state.rejectDialogVisible ? t('userReporting.rejectGroupHeader') : t('userReporting.rejectHeader')}
                name='visible'
                childrenDivClassname='row'
                onChange={(type, x, target) => {
                    if (target.value) {
                        if (this.validator.allValid()) {
                            if(this.state.rejectDialogVisible === true){
                                this.handleReject();
                            } else {
                                this.handleSingleReject();
                            }
                            this.setState({
                                rejectDialogVisible: false, singleRejectDialogVisible: false
                            });
                        } else {
                            this.validator.showMessages();
                            this.scrollToError = true;
                            this.forceUpdate();
                        }
                    } else {
                        this.setState({
                            rejectDialogVisible: false, singleRejectDialogVisible: false
                        });
                    }
                }}
                style={{
                    width: 'fit-content'
                }}
                onHide={() => {
                    this.setState({
                        rejectDialogVisible: false, singleRejectDialogVisible: false
                    });
                }}
            >
                <InputTextareaComponent
                    validator={this.validator}
                    id={'reject-reason-text-area'}
                    label={t('userReporting.reject_reason')}
                    value={this.state.rejectReason}
                    name='rejectReason'
                    showLabel={true}
                    insideTable
                    rendered={true}
                    onChange={(a, b, c, d) => {
                        this.setState({
                            rejectReason: c.target.value
                        })
                    }}
                    style={{
                        width: '100%',
                    }}
                    maxlength={100}
                    viewMode={'NEW'}
                    autoResize
                />
            </YesNoDialog>
        );
    }

    updateSearchCriteria(criteria) {
        return {
            name: criteria.name,
            project: criteria.project,
            dateFrom: criteria.dateFrom,
            dateTo: criteria.dateTo,
            status: criteria.status,
           // listType: listType,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
            userName: criteria.userName,
            reportedDayType: criteria.reportedDayType
        };
    }

    getCleanSearchCriteria() {
        return {
            name: '',
            project: '',
            status: undefined,
            id: null,
            dateFrom: '',
            dateTo: '',
            firstResult: 0,
            maxResults: 10,
            sortField: 'date',
            sortAsc: false,
            userName: '',
        };
    }

    initializeFromBackend() {                
        this.enumService
            .getEnumList('StatusLevel')
            .then((statusLevelOptions) =>
                this.setState({
                    statusLevelOptions,
                })
            )
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy statusów');
            });
    }

    
    makeBold(item, keyword) {
        let re = new RegExp(keyword, 'g')
        return (
            item.replace(re, '<b>'+keyword+ '</b>')
        )
    }
    

    searchLocations(query) {
        return this.locationService.list(query);
    }
    searchClients(query) {
        return this.clientService.list(query);
    }
    searchClientItemTemplate(item) {   
        let alreadySelected = this.state.criteria?.clients?.find(c => c.id === item.id) !== undefined;
        let address = item.address.postalCode +' '+ item.address.city +',' + item.address.streetName +', ' + item.address.country?.name;
        const style = alreadySelected ? {fontStyle: 'italic'} : {};
        return (
            <div className='row'>                                
                <div className='col-2' style={style}>Nazwa</div>
                <div className='col-10' style={style}> 
                    <span dangerouslySetInnerHTML={{__html: this.makeBold(item.name, this.state.criteria?.clientsLike)}}   />
                </div>
                <div className='col-2' style={style}>Adres</div>
                <div className='col-10' style={style}>
                <span dangerouslySetInnerHTML={{__html: this.makeBold(address, this.state.criteria?.clientsLike)}}   />
                </div>
            </div>
        );
    }

    searchLocationItemTemplate(item) {
        let alreadySelected = this.state.criteria?.locations?.find(l => l.id === item.id) !== undefined;
        const style = alreadySelected ? {fontStyle: 'italic'} : {};
        let address = item.postalCode +' '+ item.city +',' + item.streetName +', ' + item.country?.name;
        return (
            <div className='row'>                               
                <div className='col-12' style={style}>
                    <span dangerouslySetInnerHTML={{__html: this.makeBold(address, this.state.criteria?.locationsLike)}}   />
                </div>
            </div>
        );
    }

    searchProjects(query) {
        return this.projectService.search(query);
    }


    renderCriteria() {
        return (
            <div className='row'>
                <CriteriaAutocompleteComponent
                    id='project-sc'
                    name='project'
                    colClass='col-lg-4 col-sm-3'
                    label={'Projekt'}
                    value={this.state.criteria.project}
                    completeMethod={this.searchProjects.bind(this)}
                    onChange={this.handleChangeSc}
                    refreshFromBackend
                    timeoutHandler={this.refreshTimeLine}
                />
                  <CriteriaCalendarRangeComponent
                    id='date-sc'
                    idFrom='dateFrom-sc'
                    idTo='dateTo-sc'
                    label={t('project.date')}
                    labelFrom={'od'}
                    labelTo={'do'}
                    name='date'
                    nameFrom='dateFrom'
                    nameTo='dateTo'
                    colClass='col-xl-8 col-lg-8 col-sm-12'
                    from={this.state.criteria.dateFrom}
                    to={this.state.criteria.dateTo}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    refreshFromBackend
                    showButtonBar
                    sharedLabel
                    maxDateInfinite
                    placeholderFrom={''}
                    placeholderTo={''}
                    inputsClassName='col-6'
                />
                 {this.state.activeIndex !== 2 ? null :
                 <CriteriaDropdownComponent
                    id='status-sc'
                    name='status'
                    showClear
                    label={t('project.status')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.status}
                    options={this.state.statusLevelOptions}
                    placeholder='Wszystkie'
                    onChange={(a,b,c,d,e) => {
                        this.navigationContext.addOrUpdateParam("criteriaStatus", c.value);
                        this.handleChangeSc(a,b,c,d,e)}}
                    validator={this.validator}
                    optionLabel='label'
                    dataKey='enumValue'
                    filterOptionValue='label'
                    refreshFromBackend
                /> }

                   <CriteriaTextComponent
                    id='userName-sc'
                    name='userName'
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.userName}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    label={"Użytkownik"}
                    global={true}
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                />
                {this.authService.getProfile().allowGroupTimeReporting === false || this.authService.getProfile().allowMyTimeInPortal === false ? null :
                    <CriteriaDropdownComponent
                        id='reportedDayType-sc'
                        name='reportedDayType'
                        showClear
                        label={'Typ karty'}
                        colClass='col-lg-4 col-sm-6'
                        value={this.state.criteria.reportedDayType}
                        options={this.state.reportedDayTypeOptions}
                        placeholder='Wszystkie'
                        onChange={this.handleChangeSc}
                        validator={this.validator}
                        optionLabel='label'
                        dataKey='enumValue'
                        filterOptionValue='label'
                        refreshFromBackend
                    />
                }

            </div>
        );
    }
    enumTemplate(field, rowData) {
        if (rowData[field] && rowData[field].label) {
            return rowData[field].label;
        } else if (rowData[field]) {
            return rowData[field];
        }
        return '';
    }

    statusTemplate(field,rowData) {
        let classname = '';
        let label = '';

        if(rowData.status === "CREATED"){
            label = "Utworzona";
            classname = "reported-day-status-created";
        }
        if(rowData.status === "TO_APPROVE"){
            label = "Do akceptacji";
            classname = "reported-day-status-to-approve";
        }
        if(rowData.status === "APPROVED"){
            label = "Zaakceptowana";
            classname = "reported-day-status-approved";
        }
        if(rowData.status === "REJECTED"){
            label = "Odrzucona";
            classname = "reported-day-status-rejected";
        }

        return (
            <Chip
                label={label}
                className={classname}
            />
        )
    }

    generateGoToDetailUrl(item) {
        const { detailUrl, userDayDetailUrl } = this.props;
        let result = '';
        if (item?.reportType === 'SINGLE') {
            result = userDayDetailUrl + '/' + item.id;
            const date = moment(item.date).format('YYYY-MM-DD');        
            let params = `?day=${date}`
            if (item.projectId) {
                params += `&projectId=${item?.projectId}`
            }
            if (item.empModel && item.empModel.id) {
                params += `&userId=${item.empModel.id}`;
            }
            result += params;
        } else {
            result = detailUrl + '/' + item.id;
        }
        return this.navigationContext.addNavigationContextToUrl(result);
    }


    getActionTemplateOptions(rowData) {
        const items = [];
        const acceptBtnVisible = rowData.reportType === 'SINGLE' ? (rowData.level === 1 || rowData.level === 0) && rowData.status === 'TO_APPROVE' : rowData.status === 'TO_APPROVE' || rowData.status === 'REJECTED';
        const unblockBtnVisible =  rowData.status === 'APPROVED' && rowData.level >= 2;
        const rejectBtnVisible =  rowData.reportType === 'SINGLE' ? rowData.level === 1 && rowData.status === 'TO_APPROVE' : rowData.status === 'TO_APPROVE';
        if (this.authService.isUserInRole('ROLE_TIMESHEET_LIST_VIEW')) {
            items.push({isDetailOption: true});
            if (this.authService.isUserInRole('ROLE_TIMESHEET_EDIT')) {
                items.push({label: t('global.removeButton'), iconClassName: 'pi pi-delete', command: e => this.handleOpenRemoveReportedDayDialog(rowData, e.originalEvent)});
            }
            if (this.authService.isUserInRole('ROLE_TIMESHEET_EDIT') && acceptBtnVisible) {
                items.push({label: t('userReporting.confirm'), iconClassName: 'pi pi-delete', command: e => this.handleOpenApproveReportedDayDialog(rowData, e.originalEvent)});
            }
            if (this.authService.isUserInRole('ROLE_TIMESHEET_EDIT') && unblockBtnVisible) {
                items.push({label: t('userReporting.unlock'), iconClassName: 'pi pi-delete', command: e => this.handleOpenConfirmationReportedDayDialog(rowData, e.originalEvent)});
            }
            if (this.authService.isUserInRole('ROLE_TIMESHEET_EDIT') && rejectBtnVisible) {
                items.push({label: t('userReporting.reject'), iconClassName: 'pi pi-delete', command: e => this.handleOpenRejectReportedDayDialog(rowData, e.originalEvent)});
            }
        }
        return items;
    }

    handleOpenRemoveReportedDayDialog(rowData, e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ deleteConfirmDialogVisible: true, elementToRemove: rowData, dialogViewMode: 'DELETE' });
    }

    handleOpenApproveReportedDayDialog(rowData, e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ singleApproveDialogVisible: true, elementToAction: rowData});
    }
    handleOpenConfirmationReportedDayDialog(rowData, e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ openSingleConfirmationDialogVisible: true, elementToAction: rowData});
    }

    handleOpenRejectReportedDayDialog(rowData, e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ singleRejectDialogVisible: true, elementToAction: rowData });
    }


    handleDelete(e) {
        if (e) {
            e.preventDefault();
        }
        const isSingleReportType = this.state.elementToRemove.reportType === 'SINGLE';
        if (isSingleReportType) {
            this.userDayService
                .remove(this.state.elementToRemove)
                .then((response) => {
                    this.blockUi();
                    this.persistMessage('success', '', t('reportedDay.deleteSuccess'));
                })
                .catch((err) => {
                    this.persistMessage('error', '', err.message);
                })
                .finally(() => {
                    this.afterObjectUpdate();
                    this.setState({ deleteConfirmDialogVisible: false });
                });
        } else {
            this.service
                .remove(this.state.elementToRemove)
                .then((response) => {
                    this.blockUi();
                    this.persistMessage('success', '', t('reportedDay.deleteSuccess'));
                })
                .catch((err) => {
                    this.persistMessage('error', '', err.message);
                })
                .finally(() => {
                    this.afterObjectUpdate();
                    this.setState({ deleteConfirmDialogVisible: false });
                });
        }
    }
    afterObjectUpdate() {       
        this.readMessage();
        this.refreshTable();
        this.unblockUi();
    }


    employeesColumnTemplate(rowData) {
        switch (rowData.reportType) {
            case "REPORTED_DAY":
                return (
                    <div>
                        <span id='reported-day-label' data-pr-tooltip={`${rowData.reportedEmpQuantity} - Ilość zaraportowanych pracowników` + '\n' + `${rowData.empInProjectQuantity} - Ilość pracowników w projekcie `}>
                            {`${rowData.reportedEmpQuantity}/${rowData.empInProjectQuantity}`}
                        </span>
                        <Tooltip target='#reported-day-label' />
                    </div>
                )
            case "SINGLE":
                return (
                    <div>
                        <span id='employee-name-label' data-pr-tooltip={`Karta pracy użytkownika: ${rowData.empModel.name}`}>
                            {`${rowData.empModel.name}`}
                        </span>
                        <Tooltip target='#employee-name-label' />
                    </div>
                )
        }
    }

    formatTime(time) {
        if (time) {
            const hours = Math.floor(time / 60);
            const mins = time % 60;
            return `${hours}:${mins.toString().padStart(2, '0')}`;
        } else {
            return '';
        }
    }

    prepareColumns() {
        return [
            { field: 'date', header: t('reportedDay.date'), sortable: true },
            { field: 'clientName', header: t('reportedDay.client'), sortable: true },
            { field: 'projectName', header: t('reportedDay.project'), sortable: true },
            { field: 'status', header: t('reportedDay.status'), sortable: true, body: this.statusTemplate.bind(this, 'status') },
            { field: 'levelName', header: t('reportedDay.level'), sortable: true },
            { field: '', header: t('reportedDay.employees'), body: this.employeesColumnTemplate.bind(this)},
            { field: 'totalHours', header: t('reportedDay.totalHours'), body: (e) => this.formatTime(e.totalHours), sortable: true },
            {
                key: 'actions',
                header: t('list.actions'),
                body: this.actionTemplate,
                className: 'table-column-action',
            },
        ];
    }

    handleGoToNewUserDay() {
        const { newUserDayUrl } = this.props;
        this.blockUi();
        const { criteria } = this.state;
        window.location.href = this.navigationContext.addNavigationContextToUrl(newUserDayUrl);
    }

    prepareHeaderItems() {
        return( this.authService.isUserInAnyRole('ROLE_TIMESHEET_EDIT'))
            ? [
                  {
                      id: 'new-reported-day-button',
                      label: t('reportedDay.newReportedDay'),
                      type: 'BUTTON',
                      className: 'float-right',
                      variant: 'blue',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                      iconColor: 'white',
                      rendered: this.authService.getProfile().allowGroupTimeReporting,
                      onClick: this.handleGoToNew,
                },
                {
                    id: 'new-user-day-button',
                    label: t('reportedDay.newUserDay'),
                    type: 'BUTTON',
                    className: 'float-right',
                    variant: 'blue',
                    iconName: 'mdi-plus',
                    iconSide: 'left',
                    iconColor: 'white',
                    rendered: this.authService.getProfile().allowMyTimeInPortal,
                    onClick: this.handleGoToNewUserDay,
              },
              ]
            : [];
    }

    hideDeleteConfirmation() {
        this.setState({deleteConfirmDialogVisible: false});
    }

    prepareHeader(items) {
        const leftItems = [];
        const rightItems = [];
        const rightSide = [];
        if (items !== undefined && items.length > 0) {
            items.forEach((item) => {
                if (item.className !== undefined && item.className.includes('float-right')) {
                    item.className = item.className.replace('float-right', '');
                    rightItems.push(item);
                } else if (item.className !== undefined && item.className.includes('right-side')) {
                    item.className = item.className.replace('right-side', '');
                    rightSide.push(item);
                } else {
                    leftItems.push(item);
                }
            });
        }
        return (
            <DivContainer colClass='p-card-header-minheight'>
                <DivContainer colClass='col-12'>
                    <DivContainer colClass='row'>
                        <div style={{
                            display:'flex',
                            justifyContent:'start',
                            gap:'8px'
                        }}>
                            {rightItems && rightItems.length > 0
                                ? rightItems.map((item, index) =>
                                      item.customRenderFunction instanceof Function
                                          ? item.customRenderFunction()
                                          : this.renderItem(item, index)
                                  )
                                : null}
                            {/* </DivContainer> */}
                        </div>
                    </DivContainer>
                </DivContainer>
            </DivContainer>
        );
    }

    handleOnSelectAllChange(e) {

        const selectAll = e.checked;
        if (selectAll) {
            if (this.props.lazy) {
                this.setState({
                    selectAll,
                    selectAllMode: true,
                    selectedList: this.state.list,
                    unselectedList: [],
                });
            } else {
                this.setState({
                    selectAll: true,
                    selectAllMode: true,
                    selectedList: this.state.list,
                    unselectedList: [],
                });
            }
        } else {
            this.setState({
                selectAll: false,
                selectAllMode: false,
                selectedList: [],
                unselectedList: this.state.list,
                loading: false,
            });
        }
    }


    handleTabChange(e) {
        const { criteria, activeIndex } = this.state;
        this.navigationContext.addOrUpdateParam('activeIndex', e.index);
        this.setState({ prevActiveIndex: activeIndex, activeIndex: e.index, selectedList: [], selectAll: false, unselectedList: [] }, () => this.getList());
    }


    setStatusCriteria() {
        const { activeIndex } = this.state;

        if (activeIndex === 1) {
            return { enumValue: 'APPROVED', label: 'Zaakceptowany' };
        }
        if (activeIndex === 0) {
            return { enumValue: 'TO_APPROVE', label: 'Do akceptacji' }
        }

    }

    getList() {
        const {criteria, activeIndex, prevActiveIndex} = this.state;
        const statusFromCriteria = this.navigationContext.getParam('criteriaStatus');
        this.navigationContext.addOrUpdateParam("criteria", criteria);
        if(activeIndex !== 2  ){  
            criteria.status = this.setStatusCriteria();
        } 
        if(activeIndex === 2  ){
            criteria.status = statusFromCriteria;
         }
        const activeElement = document.activeElement;
        this.setState(
            {
                loading: true,
            },
            () => {
                this.service
                    .getList(criteria)
                    .then((data) => {
                        if (this._isMounted) {
                            const activeRowId = this.navigationContext.getAndRemoveCallerParam("elementId");
                            data.content.forEach(item => {
                                item.detailUrl = this.generateGoToDetailUrl(item);
                                item.editUrl = this.generateGoToEditUrl(item);
                            });
                            this.setState(
                                {
                                    list: this.updateListElements(data.content),
                                    loading: false,
                                    summary: data?.summary,
                                    size: data.totalElements,
                                    activeRowId: activeRowId ? parseInt(activeRowId) : null,
                                },
                                () => {
                                    this.onAfterGetList(data);
                                    this.setTimeout(() => activeElement?.focus(), 50);
                                    if (activeRowId) {
                                        this.setTimeout(() => this.setState({activeRowId: null}), 2000);
                                        if (this.tableRef?.current?.table) {
                                            const acviveElements = this.tableRef?.current.table.getElementsByClassName('highlight-datatable-row');
                                            if (acviveElements?.length > 0 && !this.isElementInViewport(acviveElements[0])) {
                                                acviveElements[0].scrollIntoView({
                                                    behavior: "smooth", // Płynne przewijanie
                                                    block: "center",    // Wyśrodkowanie
                                                });
                                            }
                                        }
                                    }

                                }
                            );
                        }
                    })
                    .catch((err) => {
                        if (this._isMounted) {
                            this.setState(
                                {
                                    list: [],
                                    loading: false,
                                    size: 0,
                                },
                                () => {
                                    this.afterGetListError();
                                }
                            );
                        }
                    });
            }
        );
    }

    renderView() {
        const renderHeader = this.props.renderHeader === undefined || this.props.renderHeader === true;
        return (
            <DivContainer colClass='list-main'>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                    rendered={!this.props.embedded}
                >
                    <div>
                    <Card
                        className='list-card'
                        style={{
                            border:'none'
                        }}
                        // header={this.renderHeader()}
                    >
                        <DivContainer colClass='row' rendered={this.props.hideFilters !== true}>
                            {this.renderFilter()}
                        </DivContainer>
                        <DivContainer colClass='row' rendered={renderHeader}>{this.renderHeader()}</DivContainer>
                        <TabView activeIndex={this.state.activeIndex} onTabChange={ this.handleTabChange
                            // this.navigationContext.addOrUpdateParam('activeIndex', e.index);
                            //this.setState({ activeIndex: e.index });

                        } >
              
                <TabPanel header={t('reportedDay.notAcceptedList')} key={`not-accepted-list-${this.state.activeIndex}`}>
                {this.renderDataTable(this.prepareColumns(), this.state.notAcceptedList?.content, this.state.notAcceptedList?.totalElements )}
                </TabPanel>
                <TabPanel header={t('reportedDay.acceptedList')} key={`accepted-list-${this.state.activeIndex}`}>
                {this.renderDataTable(this.prepareColumns(), this.state.acceptedList?.content, this.state.acceptedList?.totalElements )}
                </TabPanel>
                <TabPanel  header={t('reportedDay.allList')} key={`all-list-${this.state.activeIndex}`}>
                {this.renderDataTable(this.prepareColumns(), this.state.allList?.content, this.state.allList?.totalElements )}
                </TabPanel>
            </TabView>

                    </Card>
                    {this.state.downloadingPdf && <PdfDownloadSpinner />}
                    </div>

                </BlockUi>
            </DivContainer>
        );
    }

    render() {
        return (
            <div className='container-fluid' id="main-reported-day-container">
                <BreadcrumbsItem to='/reported-day-list'>{'Karty pracy'}</BreadcrumbsItem>
                {this.renderView()}
                {this.getApproveReportedDayDialog()}
                {this.getRejectReportedDayDialog()}
                {this.getOpenReportedDayDialog()}
                {this.state.deleteConfirmDialogVisible === true ?
                         <YesNoDialog
                         visible={this.state.deleteConfirmDialogVisible}
                         header='Usunięcie'
                         name='visible'
                         onChange={(type, x, target) => {
                             if (target.value) {
                                 this.handleDelete();
                             } else {
                                 this.hideDeleteConfirmation();
                             }
                         }}
                         onHide={() => {
                             this.hideDeleteConfirmation();
                         }}
                         dialogViewMode = {this.state.dialogViewMode}
                     >
                         Czy na pewno chcesz usunąć kartę pracy?
                     </YesNoDialog> : null
                }               
            </div>
        );
    }
}

ReportedDayListContainer.defaultProps = {
    detailUrl: '/#/reported-day/details',
    userDayDetailUrl: '/#/user-day/details',
    newUrl: '/#/reported-day/create',
    newUserDayUrl: '#/user-day/create',
    disableSelection: false,
    selectionMode: 'multiple',
    lazy: true,
};

ReportedDayListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(ReportedDayListContainer);
